import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

const styles = StyleSheet.create({
  headerContainer: {
    padding: 12,
    borderBottomColor: '#E0E0E0',  // Lighter border for a soft look
    borderBottomWidth: 1,
    // marginBottom: 8,
  },
  billTo: {
    color: '#333',
    fontSize: 9,      // Adjusted for clarity and balance
    fontWeight: 100,
    lineHeight: 1.6,   // More spacing for readability
    marginBottom: 4,  // Margin between cancellation texts
  },
  cancellationText: {
    fontSize: 9,      // Slightly larger for emphasis
    lineHeight: 1.6,  // Spacing between lines
    color: '#444',    // Slightly lighter color for distinction
  },
  chargeText: {
    fontSize: 9,
    lineHeight: 1.5,
    color: '#000',
    fontWeight: 'bold',
    marginTop: 6,      // Space above the charge text
  },
  cancellationHeading: {
    fontSize: 10,      // Slightly larger heading
    color: '#000',
    fontWeight: 'bold',
    marginBottom: 5,
  }
});

const CancellationModal = (data, index) => {
  return (
    <Text>
      <Text>
        {index === 0 ? "Before" : "After"}{" "}
        &#x202A;
        {index === 0
          ? moment(data.attributes.DateTo).format("Do MMM YYYY")
          : moment(data.attributes.DateFrom).format("Do MMM YYYY")}
        &#x202C;
      </Text>
      <Text style={styles.cancellationText}>
        {`- ${data.attributes.PercentPrice}% of booking amount will be charged`}
      </Text>
    </Text>
  );
};

const CancellationAccommodationEjunifer = ({ invoice }) => {
  const startDate = invoice.booking_checked_in;
  const items1 = JSON.stringify(invoice?.cancellation_policy_ejunifer);
  const items2 = JSON.parse(items1);
  const items3 = JSON.parse(items2);

  const rowsCancel =
    items3?.CancellationPolicy &&
    items3?.CancellationPolicy.PolicyRules.Rule.map((data, index) => {
      return (
        <Text style={styles.billTo} key={index}>
          {CancellationModal(data, index)} <br />
        </Text>
      );
    });

  const constData = (
    <Text style={styles.cancellationHeading}>
      Free Cancellation (100% refund) if you cancel this booking before{" "}
      {items3?.CancellationPolicy &&
        items3?.CancellationPolicy.PolicyRules.Rule.length > 0 &&
        moment(items3?.CancellationPolicy.PolicyRules.Rule[0].attributes.DateTo).format(
          "Do MMM YYYY"
        )}
      <br />
    </Text>
  );

  const chargeApplicable = (
    <Text style={styles.chargeText}>
      The cancellation charges will be applicable as follows:
    </Text>
  );

  return (
    <View style={styles.headerContainer}>
      {constData}
      {chargeApplicable}
      <Text style={{
    fontSize: 10,
    // lineHeight: 1.5,
    marginBottom: 8,
    
   }}>Cancellation Policy: </Text>
      {rowsCancel}
    </View>
  );
};

export default CancellationAccommodationEjunifer;
